export default "__VITE_ASSET__dcccb9c6__"